export enum TransactionRoleTypesEnum {
  PROJECT_ADMIN = 'PROJECT_ADMIN'
}
